import { createSelector, Selector } from 'reselect';
import { RootState } from '../../redux/root-reducer';
import { appConfiguratorStateSelector } from '../../redux/appConfigurator/selectors';
import { getJWtDetails } from '../../utils/AppUtils';

const userConfigurationSelector: Selector<RootState, RootState['configuration']['userSpecificConfiguration']> =
    createSelector(
        (state: RootState) => state.configuration,
        config => config.userSpecificConfiguration,
    );

export const messageModalOpenSelector: Selector<RootState, boolean> = createSelector(
    [appConfiguratorStateSelector],
    config => config.messageModalOpen ?? false,
);

export const unreadMessageTotalCount: Selector<RootState, number> = createSelector(
    [userConfigurationSelector, (state: RootState) => state.messages.rooms],
    (userConfig, rooms) => {
        const { user_id } = getJWtDetails();
        const currentUserId = String(user_id ?? '');
        if (!currentUserId) {
            return userConfig?.unread_messages ?? 0;
        }

        const roomBasedUnread = (rooms ?? []).reduce((total, room) => {
            const latestMessage = room?.messages?.[0];
            const latestMessageAuthorId =
                typeof latestMessage?.created_by === 'string'
                    ? latestMessage.created_by
                    : latestMessage?.created_by?._id;
            const isLatestMessageSentByCurrentUser =
                latestMessageAuthorId != null && String(latestMessageAuthorId) === currentUserId;
            if (isLatestMessageSentByCurrentUser) {
                return total;
            }
            const unreadForCurrentUser =
                room?.unread_message_count?.find(entry => String(entry.user) === currentUserId)?.count ?? 0;
            return total + unreadForCurrentUser;
        }, 0);

        // Prefer real-time room unread counts whenever rooms are available.
        if ((rooms ?? []).length > 0) {
            return roomBasedUnread;
        }

        return userConfig?.unread_messages ?? 0;
    },
);
